import { API_ROUTES } from '@/constants/apiRoutes';
import { ApiResponse, PaginatedApiResponse } from '@/react-query/context/ApiClientContextController';
import { queryFactoryOptions } from '@/react-query/utills/queryFactoryOptions';
import { AxiosInstance } from 'axios';
import { CommissionSlabs } from './slabs.types';

export interface SlabsParams {
  categoryId?: string;
  adminCommissionTypeId?: string;
  row?: number;
  fetch?: number;
  fromDateMs?: number;
  toDateMs?: number;
  createdDate?: number;
  search?: string;
}

export const getSlabs =
  (client: AxiosInstance) =>
  async (params?: SlabsParams): Promise<PaginatedApiResponse<CommissionSlabs[]>> => {
    return (
      await client.get<PaginatedApiResponse<CommissionSlabs[]>>(API_ROUTES.COMMISSION_CATEGORY_DETAIL_LIST, {
        params,
      })
    ).data;
  };

export const getCommissionCategoryDetailListDetail = (client: AxiosInstance) => async (categoryDetailId?: string) => {
  return (
    await client.get<ApiResponse<CommissionSlabs>>(API_ROUTES.GET_COMMISSION_CATEGORY_DETAIL_LIST_DETAIL, {
      params: { categoryDetailId: categoryDetailId || '' },
    })
  ).data;
};

export const commissionSlabQueries = {
  all: () => ['slabs'],
  list: (params?: SlabsParams) =>
    queryFactoryOptions<PaginatedApiResponse<CommissionSlabs[]>>({
      queryKey: [...commissionSlabQueries.all(), 'list', params],
      queryFn: (client: AxiosInstance) => () => getSlabs(client)(params),
    }),

  detail: (categoryDetailId?: string) =>
    queryFactoryOptions<ApiResponse<CommissionSlabs>>({
      queryKey: [...commissionSlabQueries.all(), 'detail', categoryDetailId],
      queryFn: (client: AxiosInstance) => () => getCommissionCategoryDetailListDetail(client)(categoryDetailId),
    }),
};
